module.exports = __webpack_public_path__ + "img/set-bg.5ce774f6.png";